<script lang="typescript">
    import type { LensVariant } from "./types";
    import type { LogoImage } from "./types";
    import { MessageType } from "./types";
    import { chevron, lensOptionDescription, lensOptionDetailURLs } from "./appData";
    import PriceDisplay from "./PriceDisplay.svelte";
    import { state, setState } from "./stores.js";
    import { push } from "svelte-spa-router";

    export let variant: LensVariant;
    export let logo: LogoImage;
    export let onToggle: () => void;

    export let lensTier: number;
    export let baseLensKey: string;
    export let primaryVariantIndex: number;

    let topImage: HTMLImageElement;

    const handleMouseEnter = () => {
        topImage.classList.add("opacity-0");
    };
    const handleMouseLeave = () => {
        topImage.classList.remove("opacity-0");
    };

    export let checked = false;

    const selectVariant = (lensTier, baseLensKey, primaryVariantIndex: number): void => {
        setState({
            message: MessageType.SET_BASE_LENS,
            lensTier,
            baseLensKey: baseLensKey,
        });
        setState({
            message: MessageType.SET_PRIMARY_VARIANT,
            primaryVariantIndex: primaryVariantIndex,
        });
        push("/results/");
    };

    const showDetails = (lensTier, baseLensKey, primaryVariantIndex: number): void => {
        setState({
            message: MessageType.SET_BASE_LENS,
            lensTier,
            baseLensKey: baseLensKey,
        });
        setState({
            message: MessageType.SET_PRIMARY_VARIANT,
            primaryVariantIndex: primaryVariantIndex,
        });
        push(lensOptionDetailURLs[variant.optionType]);
    };
</script>

<div on:mouseenter={handleMouseEnter} on:mouseleave={handleMouseLeave} class="local-container">
    <div
        class="w-16 h-16 img-background relative flex-shrink-0 mt-2"
        style={`background-image: url(${variant.image.after})`}
    >
        <img
            bind:this={topImage}
            src={variant.image.before}
            class="hide-on-hover w-full h-full object-cover rounded-full"
            alt="spectacle lens"
        />
    </div>
    <div class="flex flex-col justify-center ml-4">
        <div class="border-b border-gray-200 pb-1 flex justify-between items-end">
            {#if typeof logo !== "undefined"}
                <div class="font-medium text-3xl w-3/5">
                    <img src={logo.src} alt={logo.alt_text} class="w-3/5" />
                </div>
            {:else}
                <div class="font-medium text-3xl w-3/5">{variant.name}</div>
            {/if}
            <label class="switch">
                <input type="checkbox" bind:checked on:change={onToggle} />
                <span class="slider round" />
            </label>
        </div>
        <div class="mt-4 flex flex-row items-start justify-between h-full">
            <div class="h-full">
                <p
                    on:click={() => showDetails(lensTier, baseLensKey, primaryVariantIndex)}
                    class="cursor-pointer"
                >
                    {lensOptionDescription[variant.optionType]}
                    <span class="text-blue-500">&hellip;</span>
                </p>
            </div>
        </div>
    </div>
</div>
{#if checked}
    <button
        type="button"
        class="w-2/3 px-4 py-2 my-4 text-lg btn-primary"
        on:click={() => selectVariant(lensTier, baseLensKey, primaryVariantIndex)}
        >Order with {variant.name}</button
    >
{/if}

<style>
    .local-container {
        @apply w-full mt-6 px-4 flex justify-start items-start cursor-default;
        @apply flex-row xl:mx-auto;
    }
    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: #2196f3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>
